// DeleteConfirmationModal.js
import React from 'react';
import { AlertCircle } from 'lucide-react';

export default function DeleteConfirmationModal({ onConfirm, onCancel, message }) {
    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-card rounded-lg border border-border p-6 max-w-sm w-full">
                <div className="flex items-center mb-4">
                    <AlertCircle className="h-6 w-6 text-red-600 mr-2" />
                    <h3 className="text-lg font-medium text-foreground">확인</h3>
                </div>
                <p className="text-sm text-muted-foreground mb-4">{message}</p>
                <div className="flex gap-3">
                    <button
                        onClick={onConfirm}
                        className="flex-1 bg-destructive text-white px-4 py-2 rounded-md hover:bg-rose-700 text-sm"
                    >
                        삭제
                    </button>
                    <button
                        onClick={onCancel}
                        className="flex-1 border border-border text-foreground/80 px-4 py-2 rounded-md hover:bg-accent text-sm"
                    >
                        취소
                    </button>
                </div>
            </div>
        </div>
    );
}